import { CommonModule, NgForOf, TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { AbilityService } from '../../services/ability/ability.service';
import { SIDEBAR_LINKS } from './constants';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [MatIcon, RouterLink, TitleCasePipe, NgForOf, CommonModule],
})
export class SidebarComponent {
  links = SIDEBAR_LINKS;

  constructor(
    public ability: AbilityService,
    public router: Router) {}

  isActiveLink(link: { groups: string[] }): boolean {
    const currentUrl = this.router.url;
    return link.groups.some((path) => currentUrl.startsWith(path));
  }
}
